import { mdiDeleteOutline, mdiPencilOutline } from '@mdi/js';
import { Icon, MoreDropdown } from 'components';
import type { ExtendedMenuItem } from 'components/Menu/Menu';
import { translateUnitWithValue } from 'helpers/materialHelpers';
import { useCustomTranslation } from 'helpers/translationHelper';
import type { SelectedMaterialItem as ISelectedMaterialItem } from 'pages/material/models';
import React from 'react';

interface Props {
  item: ISelectedMaterialItem;
  onDelete: () => void;
  onEdit: () => void;
}

const SelectedMaterialItem: React.FC<Props> = (props): React.ReactElement => {
  const { item, onDelete, onEdit } = props;

  const { t } = useCustomTranslation();

  const menuItems: ExtendedMenuItem[] = [
    {
      key: 'edit',
      onClick: (e) => {
        e.domEvent.stopPropagation();
        onEdit();
      },
      label: t('common.edit'),
      icon: <Icon path={mdiPencilOutline} />
    },
    {
      key: 'delete',
      onClick: (e) => {
        e.domEvent.stopPropagation();
        onDelete();
      },
      label: t('common.delete'),
      icon: <Icon path={mdiDeleteOutline} />,
      danger: true
    }
  ];

  return (
    <div className="SelectedMaterialItem">
      <div className="SelectedMaterialItem_amount">
        {item.amount !== undefined || (item.amount === undefined && item.maxAmount)
          ? translateUnitWithValue(t, item.unit, item.amount || item.maxAmount || 0)
          : translateUnitWithValue(t, item.unit, Infinity)}
      </div>
      <div className="SelectedMaterialItem_name">{item.name}</div>
      <MoreDropdown items={menuItems} />
    </div>
  );
};

export default SelectedMaterialItem;
